module.exports = __webpack_public_path__ + "img/qrcode-icon.ede88386.svg";